export class Grupo {
  constructor({
    id = null,
    nome = null,
    nomeDeExibicao = null,
    ativo = null,
    permissoes = Array(),
  }) {
    this.id = id;
    this.nome = nome;
    this.nomeDeExibicao = nomeDeExibicao;
    this.ativo = ativo;
    this.permissoes = permissoes;
  }
  static Build() {
    return new Grupo({
      id: null,
      nome: null,
      nomeDeExibicao: null,
      ativo: null,
      permissoes: Array(),
    });
  }
  format() {
    this.permissoes = this.permissoes.map((p) => p.id);
    return this;
  }
}
